import axios from "axios";


const getParamsWithToken = (params) => {
  return {
    ...params,
    token: localStorage.getItem('_SESSION_REPORT_')
  }
}

export const fileReportDownload = (endpoint, params = {}, filenamed = "report.xlsx", isPDF = false, isOperational = false) => {
  return new Promise((resolve, reject) => {
    let baseUrl = process.env.REACT_APP_API_HISTORICAL_REPORT_URL;
    if (isPDF) baseUrl = process.env.REACT_APP_API_REPORT_PDF_URL;
    else if (isOperational) baseUrl = process.env.REACT_APP_API_OPERATIONAL_REPORT_URL;
    axios({
      url: baseUrl + endpoint,
      params: getParamsWithToken(params),
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filenamed);
      document.body.appendChild(link);
      link.click();
      resolve(1);
    }).catch(function (error) {
      reject(error);
    });
  });
};
